<template lang="pug">
  .success
    .success__lamp
      img(src="https://mindbox.ru/journal/events/ceosummit/images/success__lamp.png")
    .container
      .success__inner
        .success__bg
        .content
          .content__done
            img(src="https://mindbox.ru/journal/events/ceosummit/images/done.svg" alt="done")
          .content__title Вы&nbsp;зарегистри&shy;ро&shy;ва&shy;ны на&nbsp;CEO Summit 2022
          .content__text Ждем вас на&nbsp;встрече в&nbsp;онлайн-формате 24&nbsp;ноября в&nbsp;15:00
          .content__text Ссылка придет на&nbsp;почтовый ящик {{ participant.email }}
          .person
            .person__text Имя
            .person__text {{ participant.name }}
            .person__text Фамилия
            .person__text {{ participant.surname }}
            .person__text Телефон
            .person__text {{ participant.phone }}
            .person__text Рабочая почта
            .person__text {{ participant.email }}
            .person__text Компания
            .person__text {{ participant.site }}
            .person__text Адрес сайта
            .person__text {{ participant.company }}
            .person__text Роль в&nbsp;компании
            .person__text {{ participant.role }}
            .person__text Вопрос к&nbsp;СЕО
            .person__text {{ question }}

</template>

<script>
export default {
  name: "FormSuccess",
  props: {
    participant: {
      type: Object
    },
    question: {
      type: String
    }
  },
}
</script>

<style scoped lang="scss">
</style>